import React from "react";
import { Button, Grid, Typography, withStyles } from "@material-ui/core";
import { useState } from "react";
import GrowthModelTable from "./GrowthModelTable";
import { countOrACVFormatter } from "../../util/customFunctions";
import Tooltip from "@material-ui/core/Tooltip";

const GrowthModel = (props) => {
  const val = (props.selectedACVValue[0].acv / props.uniquarters.length) * 1.5;
  const DEFAULT_VALUE = Math.round(val / 1000000) * 1000000;
  const [target, setTarget] = useState(DEFAULT_VALUE);
  const [toggle, setToggle] = useState(true);
  const [editTarget, setEditTarget] = useState(DEFAULT_VALUE);

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "rgb(255,255,255,0.8)",
      color: "black",
      fontFamily: "roboto",
      fontSize: theme.typography.pxToRem(14),
      borderRadius: "0.5rem",
      padding: "0px",
      boxShadow: "0 0.1rem 0.1rem 0",
      marginTop: "0.1rem",
    },
  }))(Tooltip);

  const toggleInput = () => {
    setToggle(false);
  };

  const onSave = (target) => {
    setEditTarget(target);
    setToggle(true);
  };

  const handleChange = (e) => {
    setTarget(e.target.value);
  };
  return (
    <>
      <Grid item style={{ padding: "0.5rem 0.5rem" }}>
        <Typography
          align="center"
          variant="h2"
          style={{
            margin: "1rem 0rem",
            display: "flex",
            justifyContent: "center",
            padding: "1rem",
          }}
        >
          Pipeline needed by source to met growth targets
        </Typography>
        <Grid container item alignItems="left">
          <Typography
            align="left"
            variant="h2"
            style={{
              margin: "0rem 0rem",
              display: "flex",
              justifyContent: "center",
              padding: "0rem",
            }}
          >
            <span style={{ padding: "0.2rem 0.5rem" }}>
              {`Growth target - Won ${props.Value_Label} per Quarter`}
            </span>{" "}
          </Typography>

          <HtmlTooltip
            title={
              <div
                style={{
                  borderTop: "solid #fee599ff",
                  borderRadius: "0.5rem",
                  padding: "0px",
                  margin: 0,
                  borderWidth: "0.25rem",
                }}
              >
                <div className="container">
                  <Typography
                    style={{ padding: "0.1rem" }}
                    className="heading-style"
                    align="left"
                  >{`Double-click on the cell you'd like to edit`}</Typography>
                </div>
              </div>
            }
          >
            <Typography
              style={{
                background: "#fee599ff",
                padding: "0.2rem 0.4rem",
                margin: "0rem 0.5rem",
                border: "1px solid lightgrey",
                color: "black",
                fontWeight: 600,
              }}
            >
              Edit
            </Typography>
          </HtmlTooltip>
          {toggle ? (
            <Typography
              variant="h2"
              align="right"
              style={{
                padding: "0.2rem 0.5rem",
                border: "2px solid black",
                width: "10rem",
              }}
              onDoubleClick={toggleInput}
            >
              {![null, undefined, ""].includes()
                ? `$${countOrACVFormatter(DEFAULT_VALUE)}`
                : `$${countOrACVFormatter(editTarget)}`}
            </Typography>
          ) : (
            <input
              style={{
                fontSize: "1.2rem",
                margin: "0.2rem 0.5rem",
                width: "6.5rem",
                border: "2px solid black",
              }}
              type="number"
              autoFocus
              value={target}
              onChange={handleChange}
              onBlur={() => onSave(target)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  onSave(target);
                }
              }}
            />
          )}
        </Grid>
        <GrowthModelTable
          data={props.data}
          dataA={props.dataA}
          dataB={props.dataB}
          dataC={props.dataC}
          targetValue={editTarget}
        />
      </Grid>
    </>
  );
};

export default GrowthModel;
